export const dougnutBundle = {
  groups: [
    {
      title: {
        ko: "주간 누수 수용가",
        en: "Weekly Leakage Customers",
        es: "Clientes con fugas semanales"
      },
      unit: { ko: "가구", en: "HH", es: "Hogares" }
    },
    {
      title: { ko: "주간 누수율", en: "Weekly Leakage Rate", es: "Tasa de fuga semanal" },
      unit: { ko: "m³", en: "m³", es: "m³" }
    }
  ],
  dataName: {
    leak: { ko: "누수", en: "Leakage", es: "Fuga" },
    normal: { ko: "정상", en: "Normal", es: "Normal" }
  },
  tooltip: {
    rate: { ko: "비율", en: "Rate", es: "Tasa" },
    value: { ko: "값", en: "Value", es: "Valor" }
  }
}
